import {
  APIQueryResult,
  useAPIQuery,
  UseAPIQueryOptions,
} from 'shared/api/APIQuery';
import { requestCarrierAPI } from 'shared/api/CarrierAPIClient';
import { useFlaggedSchema } from 'shared/hooks/useFlaggedSchema';
import { useCarrierSettingsCache } from 'shared/settings/CarrierSettingsAPI';
import {
  CarrierInfoDTO,
  carrierInfoSchema,
  carrierInfoYupSchema,
} from './CarrierInfoDTO';
import { hasOnlyDigits } from 'shared/utils/StringUtils';

export function useCarrierInfo(
  options?: UseAPIQueryOptions<CarrierInfoDTO>,
): APIQueryResult<CarrierInfoDTO> {
  const schema = useFlaggedSchema(
    'ctms_zod_schema',
    carrierInfoYupSchema,
    carrierInfoSchema,
  );

  return useAPIQuery(
    ['profile', 'carrier-info'],
    () => requestCarrierAPI('GET /internal/web/carrier/profile/carrier-info/'),
    { ...options, schema },
  );
}

export function useUpdateCarrierInfo() {
  const { invalidateCarrierSettings } = useCarrierSettingsCache();
  return (values: Partial<CarrierInfoDTO>) => {
    return requestCarrierAPI(
      'PATCH /internal/web/carrier/profile/carrier-info/',
      {
        json: values,
      },
    ).then((response) => {
      invalidateCarrierSettings();
      return response;
    });
  };
}

export function useIsCarrierWithoutUSDOT() {
  const { data } = useCarrierInfo();
  return !data?.usdot_number || !hasOnlyDigits(data.usdot_number);
}
